import Alpine from 'alpinejs'
import AsyncAlpine from 'async-alpine'
import autoAnimate from '@marcreichel/alpine-auto-animate'
import autosize from '@marcreichel/alpine-autosize'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'

import { useLenis } from '~/scripts/composables/useLenis'
import { useTailwind } from '~/scripts/composables/useTailwind'

import registerStoreModules from '~/scripts/store'
import registerDirectives from '~/scripts/directives'
import registerComponents from '~/scripts/components'
import registerAsyncComponents from '~/scripts/async-components'
import registerMagics from '~/scripts/magics'
import { scrollToAnchor } from '~/scripts/utils/scroll'

export default function App() {
  useLenis({
    duration: 1.2,
    prevent: (element) => {
      if (element.id === '#wpadminbar') return true
      if (element.id === '#query-monitor-main') return true
      if (element.classList.contains('cky-modal')) return true
      if (element.role === 'dialog') return true
      if (element.tagName === 'DIALOG') return true
      return false
    },
  })

  globalThis.Alpine = Alpine

  // Register plugins
  Alpine.plugin(AsyncAlpine)
  Alpine.plugin(autoAnimate)
  Alpine.plugin(autosize)
  Alpine.plugin(collapse)
  Alpine.plugin(focus)
  Alpine.plugin(intersect)
  registerMagics()
  registerStoreModules()
  registerDirectives()
  registerComponents()
  registerAsyncComponents()

  document.addEventListener('alpine:initialized', async () => {
    // Make Alpine's store available globally
    const result = document.querySelector('[x-data]')

    if (result) {
      // @ts-expect-error Alpine's store will be available at this path so this is type-safe
      globalThis.$store = result._x_dataStack[0].$store
    } else {
      throw new Error(
        'No x-data found, the page should have at least one element with the x-data attribute.',
      )
    }

    const { breakpoints } = useTailwind()
    const { useDataScroll } = await import('data-scroll')
    useDataScroll({ screens: breakpoints })
  })

  Alpine.start()

  // DataLayer events
  if (globalThis.dataLayer) {
    for (const element of document.querySelectorAll<HTMLElement>(
      '[data-event]',
    )) {
      element.addEventListener('click', () => {
        const { event } = element.dataset
        if (event) {
          globalThis.dataLayer?.push({ event })
        }
      })
    }
  }

  // Smooth scroll to anchors
  for (const anchor of document.querySelectorAll<HTMLAnchorElement>(
    'main a[href*="#"]:not([href$="#"])',
  )) {
    anchor.addEventListener('click', (event) => {
      scrollToAnchor(anchor, event, { blacklist: [] })
    })
  }
}
